import { requiredRule } from '../../utils';
import { RecipeField, FieldType } from './common';

export const SALESFORCE_INSTANCE_URL: RecipeField = {
    name: 'instance_url',
    label: 'Instance Url',
    tooltip: 'Salesforce instance url',
    type: FieldType.TEXT,
    fieldPath: 'source.config.instance_url',
    placeholder: 'https://MyDomainName.my.salesforce.com',
    required: true,
    rules: requiredRule('Instance Url'),
};

export const SALESFORCE_CONSUMER_KEY: RecipeField = {
    name: 'consumer_key',
    label: 'Consumer Key',
    tooltip: 'Consumer key for Salesforce.',
    type: FieldType.TEXT,
    fieldPath: 'source.config.consumer_key',
    placeholder: 'consumer_key_123',
    required: true,
    rules: requiredRule('Consumer Key'),
};

export const SALESFORCE_CONSUMER_SECRET: RecipeField = {
    name: 'consumer_secret',
    label: 'Consumer Secret',
    tooltip: 'Consumer secret for Salesforce.',
    type: FieldType.TEXT,
    fieldPath: 'source.config.consumer_secret',
    placeholder: 'consumer_secret_123',
    required: true,
    rules: requiredRule('Consumer Secret'),
};

export const USE_REFERENCED_ENTITIES_AS_UPSTREAMS: RecipeField = {
    name: 'use_referenced_entities_as_upstreams',
    label: 'Table-level lineage',
    tooltip: 'Allow referenced entities in Salesforce as upstream.',
    type: FieldType.BOOLEAN,
    fieldPath: 'source.config.use_referenced_entities_as_upstreams',
    placeholder: 'consumer_secret_123',
    required: false,
    rules: null,
};
